import { combineReducers } from "redux";
import CreateRolssseeeReducer from "./createrole";
import ViewAllRolesReduncerre from "./viewallrole";
import AssignPermisionsReducer from "./assignpermissions";
import GetAllPermissionReducer from "./getallassignpermissions";
import ViewAllRedUsers from "./viewAllUsers";
import EditUserDataReducer from "./edituser";
import AllCountReducers from "./allcount";
import GetRolePermissions from "./rolePermissions";
import AllAssignPreDetails from "./assignpermission/allpremisesdetails";
import AllGetAssignPer from "./assignpermission/allpermissionassign";
import GetAllUsers from "./users/getAllusers";
import menu from './menu'

const reducers = combineReducers({
  menu,
  GetAllUsers,
  CreateRolssseeeReducer,
  ViewAllRolesReduncerre,
  AssignPermisionsReducer,
  GetAllPermissionReducer,
  ViewAllRedUsers,
  EditUserDataReducer,
  AllCountReducers,
  GetRolePermissions,
  AllGetAssignPer,
  AllAssignPreDetails,
});

export default reducers;
